import { useTranslation } from 'react-i18next';
import { prettyFloatMoney } from '@/helpers/utils';
import { prettyDate } from '@/helpers/date';
import { Preloader } from '@/components/Preloader';
import { EmptyContent } from '@/components/TaxReport/EmptyContent';
import { DATE_FORMAT_DD_MM_YYYY, DATE_FORMAT_MMM_YYYY } from '@/helpers/common';
import { EMPTY_DASH } from '@/helpers/constants';
import s from './index.module.scss';

export const TablePersonal = ({ data, isLoading, grouping }) => {
  const { t } = useTranslation('activity');

  return (
    <div className={s.table_wrapper}>
      <div className={s.table_inner}>
        <div className={s.table}>
          <div className={s.table__thead}>
            <div className={s.table__thead_col}>{t('portfolio_data.date')}</div>
            <div className={s.table__thead_col}>
              {grouping ? t('portfolio_data.round') : t('portfolio_data.claim')}
            </div>
            <div className={s.table__thead_col} title={t('portfolio_data.sale_price')}>
              {t('portfolio_data.sale_price')}
            </div>
            <div className={s.table__thead_col} title={t('portfolio_data.fee')}>
              {t('portfolio_data.fee')}
            </div>
            <div className={s.table__thead_col} title={t('portfolio_data.net_received')}>
              {t('portfolio_data.net_received')}
            </div>
          </div>

          {isLoading ? (
            <Preloader className={s.preloader} />
          ) : data?.total_count > 0 ? (
            <div className={s.table__tbody}>
              {data.list.map((item, index) => (
                <div key={index} className={s.table__tbody_row}>
                  <div className={s.table__tbody_col}>
                    {prettyDate(item.date, DATE_FORMAT_DD_MM_YYYY)}
                  </div>
                  <div className={s.table__tbody_col}>
                    {grouping
                      ? prettyDate(item.fundraising_start_date, DATE_FORMAT_MMM_YYYY)
                      : `#${item.loan_id}`}
                  </div>
                  <div className={s.table__tbody_col}>
                    {prettyFloatMoney(item.sale_price, {
                      decimalPlaces: 2,
                    })}
                  </div>
                  <div className={s.table__tbody_col}>
                    {item.fee
                      ? prettyFloatMoney(item.fee, {
                          decimalPlaces: 2,
                        })
                      : EMPTY_DASH}
                  </div>
                  <div className={s.table__tbody_col}>
                    {prettyFloatMoney(item.net_received, {
                      decimalPlaces: 2,
                    })}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className={s.empty}>
              <EmptyContent />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
